@if (content && product.data?.surcharge) {
<div class="col-w p-a-2 center bg-col-56 cursor-pointer"
     (click)="openModal()">
    <i class="_icon icon-delivery"></i>
    &nbsp;
    <span class="p2">
        <span *iCms="'copy' of content; content: 'html'"></span>&ensp;
        <button inlineButton
                [status]="modalStatus">
            <span *iCms="'ctaCopy' of content"></span>
        </button>
    </span>
</div>
}